import React from "react";
import SendSMSButtonProperties from "./SendSMSButtonProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import SendSMSButtonStore from "./SendSMSButtonStore";
import SmsIcon from '@mui/icons-material/Sms';
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import Modal from "../../../ui_components/Modal/Modal";
import {Observer} from "mobx-react-lite";
import {useStyles} from "./SendSMSButton.style";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import CommentInput from "../../Inputs/CommentInput/CommentInput";
import Alert from "../../../ui_components/Alert/Alert";
import AlertType from "../../../ui_components/Alert/AlertType";
import {useUserContext} from "../../../contexts/UserContext";
import Access from "../../Access/AllowAccess/Access";

const SendSMSButton: React.FC<SendSMSButtonProperties> = ({
                                                              onClick = () => {
                                                              },
                                                              onSave = () => {
                                                              },
                                                              showIcon = true,
                                                              showText = true,
                                                              disabled,
                                                              className = "",
                                                              entityIds = [],
                                                              entityType = "CLIENT",
                                                              entityName,
                                                              rounded = false,
                                                              size = ButtonSize.DEFAULT,
                                                              type = ButtonType.DEFAULT,
                                                          }) => {
    const classes = useStyles(showText);

    const i18n = useI18nContext();
    const userStore = useUserContext();
    const commonContext = useCommonContext();
    const store = new SendSMSButtonStore(commonContext, entityIds, entityType);

    const handleOnclick = async () => {
        await store.openModal();
        onClick();
    };

    const onCloseModal = () => {
        store.error = undefined;
        store.success = undefined;
        store.closeModal();
        if (onSave) {
            onSave();
        }
    };

    const onContentChange = (newContent: string) => (store.content = newContent);

    const onSend = async () => {
        const sent = await store.send();
        if (sent) {
            store.cleanModal();
            store.error = undefined;
            store.success = "OK";
        } else {
            store.success = undefined;
        }
    };

    if (!userStore.hasAccess(Access.SEND_SMS.valueOf())) {
        return <></>;
    }

    const basicText = entityType === "CLIENT"? i18n.translate("SEND_SMS"): i18n.translate("SEND_SMS_PROMO");
    const text = entityName ? entityName : basicText;
    const Icon = SmsIcon;
    const Btn = () => {
        if (rounded) {
            return (
                <RoundedButton
                    onClick={handleOnclick}
                    className={className}
                    disabled={disabled}
                    tooltip={!showText ? basicText : ""}
                    text={showText ? basicText : ""}
                    type={type}
                    icon={showIcon ? <Icon/> : <></>}
                />
            );
        }
        return (
            <Button
                text={showText ? basicText : ""}
                className={className}
                tooltip={!showText ? basicText : ""}
                disabled={disabled}
                size={size}
                onClick={handleOnclick}
                type={type}
                startIcon={showIcon ? <Icon/> : <></>}
            />
        );
    };
    return (
        <Observer>
            {() => (
                <>
                    <Modal
                        fullScreen={false}
                        loading={store.loading}
                        title={text}
                        onClose={onCloseModal}
                        open={store.isModalOpen}
                    >
                        <div className={classes.modal_container}>
                            <CommentInput
                                lines={3}
                                label={i18n.translate("MESSAGE")}
                                onChange={onContentChange}
                                fullWidth
                                value={store.content}
                                className={classes.input}
                            />
                            {store.error && (
                                <Alert
                                    className={classes.alert}
                                    text={`${i18n.translate("ERROR")}`}
                                    type={AlertType.DANGER}
                                />
                            )}
                            {store.success && (
                                <Alert
                                    className={classes.alert}
                                    text={`${i18n.translate("SMS_SENT_SUCCESS")}`}
                                    type={AlertType.SUCCESS}
                                />
                            )}
                            <Button
                                loading={store.loading}
                                className={classes.input}
                                onClick={onSend}
                                type={ButtonType.SECONDARY}
                                text={i18n.translate("SEND")}
                            />
                        </div>
                    </Modal>
                    <Btn/>
                </>
            )}
        </Observer>
    );
};

export default SendSMSButton;
